import React, { useEffect } from 'react';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';
import { Box, IconButton, InputBase, Paper } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import BuzzPagination from '../../../components/BuzzPagination/BuzzPagination';
import { convertedLeadsColumn } from './columns';
import { getConvertedLeadsAsync } from './ConvertedStore/convertedStoreSlice';
import SearchIcon from '@material-ui/icons/Search';

const ConvertedLeads = () => {
  const [page, setPage] = React.useState(1);
  const [couponCode, setCouponCode] = React.useState('');
  const dispatch = useDispatch();
  const { affiliateConvertLeads, moduleAccess } = useSelector(
    ({ ConvertedReducer, signInReducer }) => {
      return {
        affiliateConvertLeads:
          ConvertedReducer.convertedReffer &&
          ConvertedReducer.convertedReffer.data,
        moduleAccess: signInReducer.me
          ? signInReducer.me.data
            ? signInReducer.me.data.role
            : []
          : [],
      };
    }
  );

  React.useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      dispatch(
        getConvertedLeadsAsync({
          params: {
            name: '',
          },
        })
      )
        .unwrap()
        .then(() => {
          toast.success('All Leads have been fetched.');
        });
    } catch (error) {
      toast.error('Leads could not be fetched, please try after some time.');
    }
  };

  const handleSearchUser = () => {
    // API call
    dispatch(
      getConvertedLeadsAsync({
        params: {
          code: couponCode,
        },
      })
    )
      .unwrap()
      .then((res) => {
        // toast.success('All Offer Details fetched successfully.');
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  useEffect(() => {
    handleSearchUser();
  }, [couponCode]);

  const handlePageChange = (val) => {
    if (val !== page) {
      setPage(val);
      dispatch(
        getConvertedLeadsAsync({
          params: { page: val, limit: 10 },
        })
      )
        .unwrap()
        .then(() => {
          toast.success('All Leads were fetched successfully!');
        })
        .catch((err) => {
          toast.error(err.message);
        });
    }
  };

  return (
    <Box>
      <Box maxWidth={350} mb={2}>
        <Paper component="form">
          <InputBase
            placeholder="Search by Coupon Code"
            inputProps={{ 'aria-label': 'Search by Coupon Code' }}
            style={{ width: '300px', paddingLeft: '10px' }}
            onChange={(e) => setCouponCode(e.target.value.trim())}
          />
          <IconButton
            onClick={handleSearchUser}
            type="button"
            aria-label="search">
            <SearchIcon />
          </IconButton>
        </Paper>
      </Box>
      <Box mb={4}>
        <BuzzTable
          columns={convertedLeadsColumn}
          data={
            moduleAccess.includes('bccSuperAdmin')
              ? affiliateConvertLeads && affiliateConvertLeads.filteredLeads
              : affiliateConvertLeads &&
                affiliateConvertLeads.filteredLeads.filter(
                  (u) => u.code === couponCode
                )
          }
        />
        <Box display="flex" justifyContent="center" pb={3}>
          <BuzzPagination
            onClick={handlePageChange}
            total={affiliateConvertLeads && affiliateConvertLeads.count}
            pageNo={page}
            defaultPage={1}
            perPage={10}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ConvertedLeads;
